import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const Home = lazy(() => import('../pages/home/page'));
const Blog = lazy(() => import('../pages/blog/page'));
const Services = lazy(() => import('../pages/services/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const FenceServicePage = lazy(() => import('../pages/services/fence/page'));
const HandymanFAQPage = lazy(() => import('../pages/services/handyman-faq/page'));
const FenceInstallationBoiseIdaho = lazy(() => import('../pages/locations/fence-installation-boise-idaho/page'));
const BoisePermitsPage = lazy(() => import('../pages/resources/boise-fence-rules-permits/page'));
const HowToPlanFenceInstallationBoise = lazy(() => import('../pages/blog/posts/how-to-plan-fence-installation-boise'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const ReviewsPage = lazy(() => import('../pages/reviews/page'));
const VerificationChecklist = lazy(() => import('../pages/internal/verification-checklist/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

// Blog post pages
const FenceInstallationCostBoiseIdaho = lazy(() => import('../pages/blog/posts/fence-installation-cost-boise-idaho'));
const FenceInstallationCostGuideBoiseIdaho = lazy(() => import('../pages/blog/posts/fence-installation-cost-guide-boise-idaho'));
const KitchenRemodelCostBoiseIdaho = lazy(() => import('../pages/blog/posts/kitchen-remodel-cost-boise-idaho'));
const FixFlipContractorBoiseIdaho = lazy(() => import('../pages/blog/posts/fix-flip-contractor-boise-idaho'));
const BestROIHomeRemodelsBoise = lazy(() => import('../pages/blog/posts/best-roi-home-remodels-boise'));
const HandymanServicesCostBoiseIdaho = lazy(() => import('../pages/blog/posts/handyman-services-cost-boise-idaho'));

// Fence blog posts
const WoodVsVinylFenceTreasureValley = lazy(() => import('../pages/blog/posts/wood-vs-vinyl-fence-treasure-valley'));
const FenceInstallationTimelineBoise = lazy(() => import('../pages/blog/posts/fence-installation-timeline-boise'));
const BestFenceStylesBoiseNeighborhoods = lazy(() => import('../pages/blog/posts/best-fence-styles-boise-neighborhoods'));
const SignsBoiseFenceNeedsReplacement = lazy(() => import('../pages/blog/posts/signs-boise-fence-needs-replacement'));

// Handyman blog posts
const TopHomeRepairsBoiseHomeownersIgnore = lazy(() => import('../pages/blog/posts/top-home-repairs-boise-homeowners-ignore'));
const HandymanVsContractorIdaho = lazy(() => import('../pages/blog/posts/handyman-vs-contractor-idaho'));
const SeasonalHomeMaintenanceTreasureValley = lazy(() => import('../pages/blog/posts/seasonal-home-maintenance-treasure-valley'));
const DrywallRepairCostBoiseIdaho = lazy(() => import('../pages/blog/posts/drywall-repair-cost-boise-idaho'));

// Remodeling blog posts
const BlogPostBathroomRenovationROITreasureValley = lazy(() => import('../pages/blog/posts/bathroom-renovation-roi-treasure-valley'));
const BlogPostBasementFinishingCostBoiseIdaho = lazy(() => import('../pages/blog/posts/basement-finishing-cost-boise-idaho'));
const BlogPostHowToChooseRemodelingContractorBoise = lazy(() => import('../pages/blog/posts/how-to-choose-remodeling-contractor-boise'));

// Fix & Flip blog posts
const BlogPostFindReliableContractorFixFlipTreasureValley = lazy(() => import('../pages/blog/posts/find-reliable-contractor-fix-flip-treasure-valley'));
const BlogPostFixFlipROIBoiseRenovations = lazy(() => import('../pages/blog/posts/fix-flip-roi-boise-renovations'));
const BlogPostInvestorPartnershipsBoiseContractors = lazy(() => import('../pages/blog/posts/investor-partnerships-boise-contractors'));
const BlogPostFixFlipTimelineIdaho = lazy(() => import('../pages/blog/posts/fix-flip-timeline-idaho'));

// Homeowner Education blog posts
const DIYvsHiringProIdahoHomeowners = lazy(() => import('../pages/blog/posts/diy-vs-hiring-pro-idaho-homeowners'));
const HowToGetHomeImprovementEstimateBoise = lazy(() => import('../pages/blog/posts/how-to-get-home-improvement-estimate-boise'));
const HowToVetContractorIdaho = lazy(() => import('../pages/blog/posts/how-to-vet-contractor-idaho'));
const HomeMaintenanceScheduleBoiseHomeowners = lazy(() => import('../pages/blog/posts/home-maintenance-schedule-boise-homeowners'));
const LicensedInsuredContractorIdaho = lazy(() => import('../pages/blog/posts/licensed-insured-contractor-idaho'));

// Local Market blog posts
const BestNeighborhoodsBoiseHomeImprovements = lazy(() => import('../pages/blog/posts/best-neighborhoods-boise-home-improvements'));

const BlogPostBestNeighborhoodsBoise = lazy(() => import("@/pages/blog/posts/best-neighborhoods-boise-home-improvements"));
const BlogPostTreasureValleyRealEstateTrends2025 = lazy(() => import("@/pages/blog/posts/treasure-valley-real-estate-trends-2025"));
const BlogPostWhyBoiseHomeownersUpgradingFences2025 = lazy(() => import("@/pages/blog/posts/why-boise-homeowners-upgrading-fences-2025"));
const BlogPostHomeImprovementCostsMeridianVsBoise = lazy(() => import("@/pages/blog/posts/home-improvement-costs-meridian-vs-boise"));
const BlogPostTopHomeImprovementProjectsNampaCaldwell = lazy(() => import("@/pages/blog/posts/top-home-improvement-projects-nampa-caldwell-idaho"));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/about',
    element: <AboutPage />,
  },
  {
    path: '/services',
    element: <Services />,
  },
  {
    path: '/services/fence',
    element: <FenceServicePage />,
  },
  {
    path: '/services/handyman-faq',
    element: <HandymanFAQPage />,
  },
  {
    path: '/locations/fence-installation-boise-idaho',
    element: <FenceInstallationBoiseIdaho />,
  },
  {
    path: '/resources/boise-fence-rules-permits',
    element: <BoisePermitsPage />,
  },
  {
    path: '/blog/how-to-plan-fence-installation-boise',
    element: <HowToPlanFenceInstallationBoise />,
  },
  {
    path: '/blog',
    element: <Blog />,
  },
  {
    path: '/blog/fence-installation-cost-boise-idaho',
    element: <FenceInstallationCostBoiseIdaho />,
  },
  {
    path: '/blog/fence-installation-cost-guide-boise-idaho',
    element: <FenceInstallationCostGuideBoiseIdaho />,
  },
  {
    path: '/blog/wood-vs-vinyl-fence-treasure-valley',
    element: <WoodVsVinylFenceTreasureValley />,
  },
  {
    path: '/blog/fence-installation-timeline-boise',
    element: <FenceInstallationTimelineBoise />,
  },
  {
    path: '/blog/best-fence-styles-boise-neighborhoods',
    element: <BestFenceStylesBoiseNeighborhoods />,
  },
  {
    path: '/blog/signs-boise-fence-needs-replacement',
    element: <SignsBoiseFenceNeedsReplacement />,
  },
  {
    path: '/blog/kitchen-remodel-cost-boise-idaho',
    element: <KitchenRemodelCostBoiseIdaho />,
  },
  {
    path: '/blog/fix-flip-contractor-boise-idaho',
    element: <FixFlipContractorBoiseIdaho />,
  },
  {
    path: '/blog/best-roi-home-remodels-boise',
    element: <BestROIHomeRemodelsBoise />,
  },
  {
    path: '/blog/handyman-services-cost-boise-idaho',
    element: <HandymanServicesCostBoiseIdaho />,
  },
  {
    path: '/blog/top-home-repairs-boise-homeowners-ignore',
    element: <TopHomeRepairsBoiseHomeownersIgnore />,
  },
  {
    path: '/blog/handyman-vs-contractor-idaho',
    element: <HandymanVsContractorIdaho />,
  },
  {
    path: '/blog/seasonal-home-maintenance-treasure-valley',
    element: <SeasonalHomeMaintenanceTreasureValley />,
  },
  {
    path: '/blog/drywall-repair-cost-boise-idaho',
    element: <DrywallRepairCostBoiseIdaho />,
  },
  {
    path: '/blog/bathroom-renovation-roi-treasure-valley',
    element: <BlogPostBathroomRenovationROITreasureValley />,
  },
  {
    path: '/blog/basement-finishing-cost-boise-idaho',
    element: <BlogPostBasementFinishingCostBoiseIdaho />,
  },
  {
    path: '/blog/how-to-choose-remodeling-contractor-boise',
    element: <BlogPostHowToChooseRemodelingContractorBoise />,
  },
  {
    path: '/blog/find-reliable-contractor-fix-flip-treasure-valley',
    element: <BlogPostFindReliableContractorFixFlipTreasureValley />,
  },
  {
    path: '/blog/fix-flip-roi-boise-renovations',
    element: <BlogPostFixFlipROIBoiseRenovations />,
  },
  {
    path: '/blog/investor-partnerships-boise-contractors',
    element: <BlogPostInvestorPartnershipsBoiseContractors />,
  },
  {
    path: '/blog/fix-flip-timeline-idaho',
    element: <BlogPostFixFlipTimelineIdaho />,
  },
  {
    path: '/blog/diy-vs-hiring-pro-idaho-homeowners',
    element: <DIYvsHiringProIdahoHomeowners />,
  },
  {
    path: '/blog/how-to-get-home-improvement-estimate-boise',
    element: <HowToGetHomeImprovementEstimateBoise />,
  },
  {
    path: '/blog/how-to-vet-contractor-idaho',
    element: <HowToVetContractorIdaho />,
  },
  {
    path: '/blog/home-maintenance-schedule-boise-homeowners',
    element: <HomeMaintenanceScheduleBoiseHomeowners />,
  },
  {
    path: '/blog/licensed-insured-contractor-idaho',
    element: <LicensedInsuredContractorIdaho />,
  },
  {
    path: '/blog/best-neighborhoods-boise-home-improvements',
    element: <BestNeighborhoodsBoiseHomeImprovements />,
  },
  {
    path: "/blog/best-neighborhoods-boise-home-improvements",
    element: <BlogPostBestNeighborhoodsBoise />,
  },
  {
    path: "/blog/treasure-valley-real-estate-trends-2025",
    element: <BlogPostTreasureValleyRealEstateTrends2025 />,
  },
  {
    path: "/blog/why-boise-homeowners-upgrading-fences-2025",
    element: <BlogPostWhyBoiseHomeownersUpgradingFences2025 />,
  },
  {
    path: "/blog/home-improvement-costs-meridian-vs-boise",
    element: <BlogPostHomeImprovementCostsMeridianVsBoise />,
  },
  {
    path: "/blog/top-home-improvement-projects-nampa-caldwell-idaho",
    element: <BlogPostTopHomeImprovementProjectsNampaCaldwell />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '/reviews',
    element: <ReviewsPage />,
  },
  {
    path: '/internal/verification-checklist',
    element: <VerificationChecklist />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;